import React from 'react';
import { FiCheck, FiEdit2, FiPlay, FiTrash2 } from 'react-icons/fi';
import { formatMinutes } from '../utils/dateUtils';

const STATUS_LABEL = {
  planned: '미완료',
  progress: '진행 중',
  completed: '완료',
};

const ScheduleItem = ({ plan, onComplete, onDelete, onEdit, onStatusChange }) => (
  <article className={`scheduler-plan is-${plan.status}`}>
    <span className="scheduler-plan__line" aria-hidden="true" />
    <div className="scheduler-plan__time">
      <strong>{plan.startTime}</strong>
      <span>{plan.endTime}</span>
    </div>

    <div className="scheduler-plan__content">
      <div>
        <span className="scheduler-plan__subject">{plan.subject}</span>
        <em>{STATUS_LABEL[plan.status] || '미완료'}</em>
      </div>
      <strong>{plan.planContent}</strong>
      <small>
        계획 {formatMinutes(plan.expectedMinutes)}
        {Number(plan.actualMinutes) > 0 && ` · 실제 ${formatMinutes(plan.actualMinutes)}`}
      </small>
      {plan.actualContent && <p>{plan.actualContent}</p>}
      {Number(plan.understanding) > 0 && (
        <span className="scheduler-plan__rating" aria-label={`이해도 ${plan.understanding}점`}>
          {'★'.repeat(Number(plan.understanding))}{'☆'.repeat(5 - Number(plan.understanding))}
        </span>
      )}
    </div>

    <div className="scheduler-plan__actions">
      <button type="button" onClick={() => onEdit(plan)} aria-label={`${plan.subject} 계획 수정`}>
        <FiEdit2 aria-hidden="true" />
      </button>
      <button type="button" onClick={() => onDelete(plan)} aria-label={`${plan.subject} 계획 삭제`}>
        <FiTrash2 aria-hidden="true" />
      </button>
      <button
        type="button"
        className="scheduler-plan__status"
        onClick={() => (
          plan.status === 'planned' ? onStatusChange(plan, 'progress') : onComplete(plan)
        )}
        aria-label={`${plan.subject} 상태 변경`}
      >
        {plan.status === 'completed' ? <FiCheck aria-hidden="true" /> : <FiPlay aria-hidden="true" />}
        <span>{plan.status === 'completed' ? '기록' : plan.status === 'progress' ? '완료하기' : '시작'}</span>
      </button>
    </div>
  </article>
);

export default ScheduleItem;
